import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import { getImageUrl } from '@otovo/shared/lib/sanity/imageUrlUtils';
import { Otovo$Locale } from '@otovo/shared/types/otovoweb';
import { Sanity$CTAWithFullPageImage } from '@otovo/shared/types/sanityTypes';
import { useRouter } from 'next/router';
import { PortablePTag } from '../../Sanity/PortableTextComponents';
import CTAButton from '../../v2/CTAButton';
import { routeToHref } from '../routeToHrefUtil';

type Props = {
  content: Sanity$CTAWithFullPageImage;
};

const CTAWithFullPageImage = ({ content }: Props) => {
  const config = useGlobalConfig();
  const { locale } = useRouter() as { locale: Otovo$Locale };
  const backgroundImageUrl = getImageUrl(content.backgroundImage);
  return (
    <div
      className="color-scheme-white relative bg-surface"
      data-testid="cta-with-full-page-image"
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${backgroundImageUrl})`,
        }}
      />
      <div
        // Vignette filter
        className="absolute inset-0"
        style={{
          background: `
                radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.4) 70%, rgba(0,0,0,0.7) 100%),
                linear-gradient(0deg, rgba(13, 18, 28, 0.3) 0%, rgba(13, 18, 28, 0.3) 100%)
              `,
        }}
      />

      <div className="color-scheme-dark relative mx-auto max-w-8xl px-4 py-16 md:px-6 md:py-20 lg:px-16 lg:py-32">
        <div className="grid-cols-12 gap-6 md:mx-auto md:max-w-96 lg:grid lg:max-w-none">
          <div className="col-span-7 col-start-4 text-center lg:col-span-4 lg:col-start-8">
            <h2 className="text-2xl font-semibold text-balance text-heading md:text-3xl lg:text-4xl">
              {content.heading}
            </h2>
            <div className="mt-96 lg:mt-64">
              <PortablePTag
                className="text-base text-subheading md:text-xl"
                value={content.description}
              />

              {content.cta && (
                <CTAButton
                  href={routeToHref(
                    content.cta.route,
                    config.BU_CONFIG.market,
                    locale,
                  )}
                  className="mt-6 block"
                >
                  {content.cta.title}
                </CTAButton>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTAWithFullPageImage;
